import { PERMISSIONS } from '../shared/constants/permissions';

export default class PermissionService {

  static isGranted(grantedPermissions, requestedPermission) {
    return grantedPermissions?.[requestedPermission] || false;
  }
}
